import { Flex } from "@chakra-ui/react";
import { Control } from "react-hook-form";
import Field from "components/Input/Field/index";
import SelectTipoContabilizacao from "components/Input/SelectTipoContabilizacao/index";
import OutlineButton from "components/Button/OutlineButton";
import {
  ExportacaoContabilForm,
  TipoContabilizacaoEnum,
} from "features/exportacao-contabil/typings";
import { Input } from "@chakra-ui/input";
import { FiltroExportacaoContabil } from "features/exportacao-contabil/typings";
import ModalDetalhamentoContaCategoria from "components/RelatorioDemonstrativoReceitaDespesa/ModalDetalhamentoContaCategoria";
import { useState } from "react";
import { OperacaoEnum } from "core/resources/enums/conta";

export default function RowTablePagamentoCompras({
  control,
  despesa,
  form,
  index,
  filtro,
}: {
  despesa?: {
    id: string;
    codigoIntegracao: string | null;
    nome: string;
    pessoas: {
      id: string;
      codigoIntegracao: string | null;
      nome: string;
    }[];
    valor: number;
  };
  control: Control<ExportacaoContabilForm, object>;
  form: ExportacaoContabilForm;
  index: number;
  filtro: FiltroExportacaoContabil;
}) {
  const [isOpenDetalhamento, setIsOpenDetalhamento] = useState(false);

  const tipoContabilizacao = form.despesas?.[index]?.tipoContabilizacao;
  return (
    <>
      <Flex
        w="100%"
        borderX="solid 1px #EBEBEB"
        borderBottom="solid 1px #EBEBEB"
        flexDir="column"
      >
        <Flex w="100%" gap={4} px={8} py={2}>
          <Flex flex={4} align="center">
            <Field
              control={control}
              name={`despesas.${index}.categoriaFinanceiraId`}
              render={() => <Flex>{despesa?.nome}</Flex>}
            />
          </Flex>
          <Flex flex={2}>
            <Field
              control={control}
              name={`despesas.${index}.tipoContabilizacao`}
              shouldUnregister
              render={({ field }) => (
                <SelectTipoContabilizacao tipo="fornecedor" {...field} />
              )}
            />
          </Flex>
          <Flex flex={2}>
            <Field
              control={control}
              name={`despesas.${index}.codigoIntegracao`}
              render={({ field }) => (
                <Input
                  disabled={
                    tipoContabilizacao ===
                    TipoContabilizacaoEnum.BaixaFornecedor
                  }
                  value={field.value}
                  onChange={(v) => field.onChange(v.target.value)}
                />
              )}
            />
          </Flex>

          <Flex flex={2}>
            <OutlineButton onClick={() => setIsOpenDetalhamento(true)}>
              Ver lançamento
            </OutlineButton>
          </Flex>
        </Flex>

        {tipoContabilizacao === TipoContabilizacaoEnum.BaixaFornecedor ||
        tipoContabilizacao === TipoContabilizacaoEnum.ProvisaoBaixaFornecedor
          ? despesa?.pessoas.map((pessoa, indexPessoa) => (
              <Flex w="100%" gap={4} px={8} py={2} key={pessoa.id}>
                <Flex flex={4} align="center">
                  <Flex pl={4}>{pessoa.nome}</Flex>
                </Flex>
                <Flex flex={2} />
                <Flex flex={2}>
                  <Field
                    control={control}
                    name={`despesas.${index}.pessoas.${indexPessoa}.codigoIntegracao`}
                    shouldUnregister
                    render={({ field }) => (
                      <Input
                        value={pessoa?.codigoIntegracao!}
                        onChange={(v) => field.onChange(v.target.value)}
                      />
                    )}
                  />
                </Flex>
                <Flex flex={2} />
              </Flex>
            ))
          : null}

        {isOpenDetalhamento ? (
          <ModalDetalhamentoContaCategoria
            isOpenModal={!!isOpenDetalhamento}
            onClose={() => setIsOpenDetalhamento(false)}
            id={despesa?.id}
            item={{
              operacao: OperacaoEnum.Despesa,
              nome: despesa?.nome,
            }}
            params={{
              dataInicio: filtro.dataInicio,
              dataFim: filtro.dataFim,
            }}
          />
        ) : null}
      </Flex>
    </>
  );
}
